function App(props) {

  var palette1 = props.palette1;
  var changeCP = props.changeCP;
  var cp = props.cp;
  var toHighlight = props.toHighlight;

  var x = [];

  palette1.forEach((aPalette, index)=>{

    var ins = {width:'80%', marginTop:'20px', cursor:'pointer', border:'1px solid black'};
      var alreadyGot = false;
      if (cp[aPalette.v[0].v]){
        alreadyGot = true;
      }

      var pp = aPalette.v.filter((aP, index2)=>{
        return +index2 > 1 && +index2 < 9 && aP.v
      });

      var width = 0;
      if (pp.length > 0){
        width = (100/pp.length) + '%';
      }

      var cells = pp.map((aP, index2)=>{
        return <td style={{backgroundColor:aP.v, width, height:'20px', border:'1px solid black', textAlign:'center', verticalAlign:'middle'}} key={index2}></td>
//
      })

      var ppButtons = aPalette.v.filter((aP, index2)=>{
        return +index2 > 8 && +index2 < 12 && aP.v
      });

      var cellsButton = ppButtons.map((aP, index2)=>{
        return <td style={{height:'20px', borderLeft:'1px solid black', borderBottom:'1px solid black', borderRight:'1px solid black', textAlign:'center', color:'black', verticalAlign:'middle'}} key={index2}><div className={'btn btn-'+aP.v}></div></td>
//
      })

      if (toHighlight === aPalette.v[0].v){
        if (cellsButton.length === 0){
          ins.border = '3px solid black';
        }else{
          ins.borderLeft = '3px solid black';
          ins.borderTop = '3px solid black';
          ins.borderRight = '3px solid black';
        }
      }

      x.push(<table style={ins} key={index} onClick={changeCP(aPalette.v[0].v, pp, alreadyGot)} className='cellSelector'><tbody><tr>{cells}</tr></tbody></table>)
//
      if (cellsButton.length > 0){
        var bAmt = '1px solid black';
        if (toHighlight === aPalette.v[0].v){
          bAmt = '3px solid black';
        }
        var ins1 = {width:'80%', cursor:'pointer', borderLeft:bAmt, borderBottom:bAmt, borderRight:bAmt};
          x.push(<table style={ins1} key={index} onClick={changeCP(aPalette.v[0].v, pp, alreadyGot)} className='cellSelector'><tbody><tr>{cellsButton}</tr></tbody></table>)
      }

    })

    return <div>{x}</div>
}

export default App;
